import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { EfoEgiService } from './egi.service';

@Injectable({
  providedIn: 'root',
})
export class GoogleService {
  constructor(private efoEgi: EfoEgiService) {}
  distFrom = (lat1, lng1, lat2, lng2) => {
    const earthRadius = 3958.75;
    let dLat = ((lat2 - lat1) * Math.PI) / 180;
    let dLng = ((lng2 - lng1) * Math.PI) / 180;
    let sindLat = Math.sin(dLat / 2);
    let sindLng = Math.sin(dLng / 2);
    let a =
      Math.pow(sindLat, 2) +
      Math.pow(sindLng, 2) *
        Math.cos(Math.PI / 180) *
        Math.cos((lat2 * Math.PI) / 180);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let dist = earthRadius * c;
    return dist;
  };
  competition: any = [];

  getCompetition = (longitude, latitude, callback?) => {
    if (this.competition.length == 0) {
      this.efoEgi
        .getData('/yp/getGoogleDealers', {
          latitude: latitude,
          longitude: longitude,
        })
        .subscribe((response) => {
          let results = response.results;
          _.each(results, (d) => {
            d['distance'] = this.distFrom(
              latitude,
              longitude,
              d.geometry.location.lat,
              d.geometry.location.lng,
            );
          });
          this.competition = _.sortBy(results, 'distance');
          if (_.isFunction(callback)) {
            callback(null);
          }
        });
    }
  };
}
